exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-form[data-v-36d2363a] {\n    max-width: 300px;\n    width: 100%;\n    margin: auto;\n}\n", ""]);

// exports
